import { type ReactNode } from 'react';
import { ItemsTable } from 'receivable-invoices-js/react/components/items-table';
import { CreditNotesActions } from 'receivable-invoices-js/react/components/credit-notes/actions';
import { CreditNotesInformation } from 'receivable-invoices-js/react/components/credit-notes/information';
import type { CreditNote } from 'receivable-invoices-js/react/api/models/credit-note';
import styles from '../responsive-view.module.css';

interface CreditNoteContentProps {
  document: CreditNote;
}

export function CreditNoteContent({ document }: CreditNoteContentProps): ReactNode {
  return (
    <div className={styles.details} data-testid="credit-note-content">
      <CreditNotesInformation
        className={styles.information}
        creditNote={document}
        data-testid="credit-note-information"
      />
      <CreditNotesActions
        className={styles.actions}
        data-testid="credit-note-actions"
        pdfUrl={document.pdfUrl || ''}
      />
      <ItemsTable
        className={styles.itemsTable}
        data-testid="credit-note-items-table"
        items={document.items}
      />
    </div>
  );
}
